'use client'

import clsx from 'clsx'
import { FC, ReactNode, useEffect, useRef } from 'react'

import cls from './Collapse.module.scss'

interface CollapseProps {
	children: ReactNode
	open?: boolean
}

const DEFAULT_ROOT_STYLE = { height: `0px` }

export const Collapse: FC<CollapseProps> = ({ children, open = false }) => {
	const ref = useRef(null)
	const innerRef = useRef(null)
	const timerRef = useRef(null)
	useEffect(() => {
		if (!ref.current) return
		const correctFunc = open ? openContent : closeContent
		correctFunc()
	}, [open])

	const closeContent = () => {
		const container = ref.current
		container.style.willChange = 'height'
		const height = innerRef.current.scrollHeight
		container.style.height = `${height}px`
		container.offsetHeight
		container.style.height = `0px`
		clearTimeout(timerRef.current)
	}

	const openContent = () => {
		const container = ref.current
		container.style.willChange = 'height'
		const height = innerRef.current.scrollHeight
		container.style.height = `${height}px`

		timerRef.current = setTimeout(() => {
			container.style.height = ``
		}, 300)
	}

	return (
		<div className={cls.root} style={DEFAULT_ROOT_STYLE} ref={ref}>
			<div className={clsx(cls.inner, !open && cls.inner_hide)} ref={innerRef}>
				{children}
			</div>
		</div>
	)
}
